import React, { Component } from "react";
import UpdateDocument from "./updateDocuments";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";

import Popup from "../../../../common/popup";
import {  AiFillEye } from "react-icons/ai";

/**
 * Document Upload Component for displaying the user Document details.
 */
class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      uploadData:[],
      updateData: null,
      validid: false,
      isOpen: false,
      resumeOpen: null,
      isToogle:false,
     
      deletePopupId :"",
  
   
      edit: "",
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
   
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.fetchDocument = this.fetchDocument.bind(this);
    this.onOpenResume = this.onOpenResume.bind(this);
    this.deleteAward = this.deleteAward.bind(this)
  }


  // close add form
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }

 

  // toggle popup detail
  togglePopup(detail) {
    console.log("value");
    this.setState({
      isOpen: !this.state.isOpen,
      deletePopupId: detail
    });
  }

  // open toggle resume
  onOpenResume(data) {
    this.setState({
      resumeOpen: data,
      isToogle:!this.state.isToogle
      
    });
  }

 // open add form
openAddForm(detail) {
    console.log(detail);
    this.setState({
      updateData: null,
      updateBtn: true,
    });
  }

  // close update form
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.fetchDocument();
  }


  componentDidMount() {
    
    this.fetchDocument();
  }

  // fecth all documents

fetchDocument() {
    axios
      .get(`${API_CANDIDATE}/v1/api/upload-document/common`, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res.data)
        this.setState({
          uploadData: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // delete document function
  deleteAward(obj) {
    let body = {
      id:obj
    }

    axios
      .delete(`${API_CANDIDATE}/v1/api/upload-document`,{
        withCredentials: true,
        data: body
      })
      .then((res) => {
        console.log(res.data.ok);
        if (res.data.ok) {
          console.log("inside")
          this.setState({
            isOpen: false,
          });
          this.fetchDocument();
         
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

 

 
 

  render() {
   

    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              
              }}
              className="details-flex-main-div"
            >
              <div style={{ paddingTop: "20px", height: "60px" }}>
                <h5  style={{ fontWeight: 500,fontSize:"1.25rem",paddingLeft:"2rem" }}> Upload Documents</h5>
              </div>
              <div
                className="tooltipj"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={this.openAddForm}
                  type="submit"
                  style={{
                    background: "green",
                    marginTop: "10px",
                    color: "white",
                  }}
                  className="tooltipcommon"
                >
                  ADD
                </Button>
              </div>
            </div>
            { this.state.uploadData.map((detail) => (
           
              <div
                key={detail.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  
                
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingLeft: "2rem",
                    paddingBottom: "15px",
                    width: "100%",
                    // marginTop: "20px",
                    borderRadius: "15px",
                  }}
                >
                
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                     
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginBottom:"1rem",
                          width:"50%",
                          margin:"auto",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span style={{fontWeight: "500", fontSize:"0.875rem", }}> {detail.doumentName}</span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // marginRight:"2rem"
                          }}
                        >
                          <h3
                            style={{ cursor: "pointer"}}
                            onClick={()=>this.onOpenResume(detail.id)}
                          >
                            {" "}
                            <AiFillEye />{" "}
                          </h3>
                       
                          <h3
                            style={{ color: "red", marginLeft: "1.5rem" }}
                            onClick={()=>this.togglePopup(detail)}
                            className="material-icons pointer contact-delete-btn"
                          >
                            delete
                          </h3>
                        </div>
                      </div>

                      { this.state.resumeOpen === detail.id &&  this.state.isToogle &&  (
                        <iframe
                          src={`${API_CANDIDATE}/documents/${detail.fileName}`}
                          width="90%"
                          height="600rem"
                        ></iframe>
                      )}
                      {this.state.isOpen && (
                        <Popup
                          isOpenModal={this.togglePopup}
                          isOnDelete={this.deleteAward}
                          detail={this.state.deletePopupId}
                        />
                      )}
                    </div>
             

                

                

               
                </div>

             
              </div>
            ))}
          </>
        ) : null}
        {updateBtn && (
          <UpdateDocument
            back={this.closeUpdateForm}
            updateDataProp={this.state.updateData}
            edit={this.state.edit}
            data={data}
          />
        )}
      </>
    );
  }
}

export default Document;
